export type ProfileTier = 'platinum' | 'gold' | 'silver' | 'branded' | 'basic';
export type DepthTier = 'platinum' | 'gold' | 'silver' | 'none';

export type TierDetails = {
  profileTier: ProfileTier;
  depthTier: DepthTier;
};

export const isStarRatingDesignApplicable = ({
  profileTier,
  depthTier,
}: TierDetails): boolean =>
  // Use star rating design for platinum, gold and silver tiers
  profileTier === 'platinum' ||
  (profileTier === 'branded' &&
    (depthTier === 'gold' || depthTier === 'silver'));
